import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelRadio as _vModelRadio, withDirectives as _withDirectives, withKeys as _withKeys, vModelText as _vModelText, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, normalizeClass as _normalizeClass, vShow as _vShow, createTextVNode as _createTextVNode, vModelSelect as _vModelSelect, createVNode as _createVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-bf6677d6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "add-edit-modal" }
const _hoisted_2 = { class: "heading-text" }
const _hoisted_3 = { class: "line1" }
const _hoisted_4 = { class: "line2" }
const _hoisted_5 = { class: "ls-form" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Type", -1))
const _hoisted_7 = { class: "radio-group" }
const _hoisted_8 = { class: "radio" }
const _hoisted_9 = ["disabled"]
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "radio-elmt" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "radio-checkmark-box" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "radio-checkmark" })
  ]),
  /*#__PURE__*/_createElementVNode("span", { class: "radio-text" }, "Practitioner")
], -1))
const _hoisted_11 = { class: "radio" }
const _hoisted_12 = ["disabled"]
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "radio-elmt" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "radio-checkmark-box" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "radio-checkmark" })
  ]),
  /*#__PURE__*/_createElementVNode("span", { class: "radio-text nowrap" }, "Associate (Jointly)")
], -1))
const _hoisted_14 = {
  key: 0,
  class: "row"
}
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "LawID / Name", -1))
const _hoisted_16 = {
  key: 0,
  class: "autocomplete",
  style: {"flex":"0 0 100%"}
}
const _hoisted_17 = ["disabled"]
const _hoisted_18 = { class: "icon-hm" }
const _hoisted_19 = {
  key: 0,
  class: "fal fa-spinner fa-spin fa-lg"
}
const _hoisted_20 = {
  key: 1,
  class: "fal fa-search fa-lg"
}
const _hoisted_21 = {
  id: "autocomplete-results",
  class: "autocomplete-results"
}
const _hoisted_22 = ["innerHTML", "onClick"]
const _hoisted_23 = {
  key: 0,
  class: "validation-msg"
}
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fal fa-exclamation-circle" }, null, -1))
const _hoisted_25 = { key: 1 }
const _hoisted_26 = { class: "input-box" }
const _hoisted_27 = ["disabled", "value"]
const _hoisted_28 = {
  key: 1,
  class: "row"
}
const _hoisted_29 = { class: "col-6" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "First name *", -1))
const _hoisted_31 = { class: "input-box" }
const _hoisted_32 = ["disabled"]
const _hoisted_33 = {
  key: 0,
  class: "validation-msg"
}
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fal fa-exclamation-circle" }, null, -1))
const _hoisted_35 = { class: "col-6" }
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Last name *", -1))
const _hoisted_37 = { class: "input-box" }
const _hoisted_38 = ["disabled"]
const _hoisted_39 = {
  key: 0,
  class: "validation-msg"
}
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fal fa-exclamation-circle" }, null, -1))
const _hoisted_41 = { class: "row" }
const _hoisted_42 = { class: "col-12" }
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Position *", -1))
const _hoisted_44 = { class: "input-box" }
const _hoisted_45 = {
  class: "select mb-4",
  style: {"width":"100%"}
}
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", {
  disabled: "",
  value: "0"
}, "- Please select -", -1))
const _hoisted_47 = ["value"]
const _hoisted_48 = {
  key: 0,
  class: "validation-msg",
  style: {"position":"absolute","margin-top":"4.6em"}
}
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fal fa-exclamation-circle" }, null, -1))
const _hoisted_50 = { class: "row" }
const _hoisted_51 = { class: "col-12" }
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Solely/ jointly *", -1))
const _hoisted_53 = { class: "input-box" }
const _hoisted_54 = {
  class: "select mb-4",
  style: {"width":"100%"}
}
const _hoisted_55 = ["disabled"]
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", {
  disabled: "",
  value: "0"
}, "- Please select -", -1))
const _hoisted_57 = ["value"]
const _hoisted_58 = {
  key: 0,
  class: "validation-msg",
  style: {"position":"absolute","margin-top":"4.6em"}
}
const _hoisted_59 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fal fa-exclamation-circle" }, null, -1))
const _hoisted_60 = { class: "row" }
const _hoisted_61 = { class: "col-6" }
const _hoisted_62 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Commenced Date *", -1))
const _hoisted_63 = { class: "input-box" }
const _hoisted_64 = {
  class: "date-picker",
  style: {"width":"100%"}
}
const _hoisted_65 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fal fa-calendar-check" }, null, -1))
const _hoisted_66 = { class: "col-6" }
const _hoisted_67 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Terminated Date", -1))
const _hoisted_68 = { class: "input-box" }
const _hoisted_69 = {
  class: "date-picker",
  style: {"width":"100%"}
}
const _hoisted_70 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fal fa-calendar-check" }, null, -1))
const _hoisted_71 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_72 = { class: "row" }
const _hoisted_73 = {
  key: 0,
  class: "col-6"
}
const _hoisted_74 = ["disabled"]
const _hoisted_75 = ["disabled"]
const _hoisted_76 = ["disabled"]
const _hoisted_77 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("i", { class: "fal fa-angle-right" })
], -1))
const _hoisted_78 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "CANCEL ALERT", -1))
const _hoisted_79 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Do you want to cancel this task?", -1))

export function render(_ctx, _cache) {
  const _component_LoadingSpinner = _resolveComponent("LoadingSpinner")
  const _component_v3_date_picker = _resolveComponent("v3-date-picker")
  const _component_ModalBox = _resolveComponent("ModalBox")
  const _component_ConfirmDialogue = _resolveComponent("ConfirmDialogue")
  const _component_AlertBox = _resolveComponent("AlertBox")

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    (_ctx.isLoadingData)
      ? (_openBlock(), _createBlock(_component_LoadingSpinner, { key: 0 }))
      : _createCommentVNode("", true),
    _createVNode(_component_ModalBox, {
      show: _ctx.show,
      "onUpdate:show": _cache[22] || (_cache[22] = $event => ((_ctx.show) = $event)),
      halfScreen: true,
      onClose: _cache[23] || (_cache[23] = $event => (_ctx.cancelClicked()))
    }, {
      "header-text": _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.headerText), 1),
          _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.line2Text), 1)
        ])
      ]),
      body: _withCtx(() => [
        _createElementVNode("form", _hoisted_5, [
          _createElementVNode("fieldset", null, [
            _hoisted_6,
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("label", _hoisted_8, [
                _withDirectives(_createElementVNode("input", {
                  type: "radio",
                  name: "member-type",
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ((_ctx.signatoryRequest.signatoryTypeId) = $event)),
                  value: 1,
                  disabled: _ctx.editMode
                }, null, 8, _hoisted_9), [
                  [_vModelRadio, _ctx.signatoryRequest.signatoryTypeId]
                ]),
                _hoisted_10
              ]),
              _createElementVNode("label", _hoisted_11, [
                _withDirectives(_createElementVNode("input", {
                  type: "radio",
                  name: "member-type",
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => ((_ctx.signatoryRequest.signatoryTypeId) = $event)),
                  value: 2,
                  disabled: _ctx.editMode
                }, null, 8, _hoisted_12), [
                  [_vModelRadio, _ctx.signatoryRequest.signatoryTypeId]
                ]),
                _hoisted_13
              ])
            ])
          ]),
          (_ctx.signatoryRequest.signatoryTypeId == 1)
            ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                _createElementVNode("fieldset", null, [
                  _hoisted_15,
                  (!_ctx.editMode)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                        _withDirectives(_createElementVNode("input", {
                          onKeydown: [
                            _cache[2] || (_cache[2] = _withKeys((...args) => (_ctx.onArrowDown && _ctx.onArrowDown(...args)), ["down"])),
                            _cache[3] || (_cache[3] = _withKeys((...args) => (_ctx.onArrowUp && _ctx.onArrowUp(...args)), ["up"])),
                            _cache[4] || (_cache[4] = _withKeys((...args) => (_ctx.onEnter && _ctx.onEnter(...args)), ["enter"]))
                          ],
                          disabled: _ctx.editMode,
                          class: "searchField",
                          type: "text",
                          "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => ((_ctx.search) = $event)),
                          placeholder: "Search LawID,  name"
                        }, null, 40, _hoisted_17), [
                          [_vModelText, _ctx.search]
                        ]),
                        _withDirectives(_createElementVNode("input", {
                          type: "hidden",
                          id: "lawId",
                          name: "lawId",
                          "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => ((_ctx.signatoryRequest.lawId) = $event))
                        }, null, 512), [
                          [_vModelText, _ctx.signatoryRequest.lawId]
                        ]),
                        _createElementVNode("span", _hoisted_18, [
                          (_ctx.isSearching)
                            ? (_openBlock(), _createElementBlock("i", _hoisted_19))
                            : (_openBlock(), _createElementBlock("i", _hoisted_20))
                        ]),
                        _withDirectives(_createElementVNode("ul", _hoisted_21, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.userList, (user, i) => {
                            return (_openBlock(), _createElementBlock("li", {
                              key: i,
                              class: _normalizeClass(["autocomplete-result", { 'is-active': i === _ctx.arrowCounter }]),
                              innerHTML: _ctx.highlightWord(user.lawId + ' - ' + user.givenName + ' ' + user.surname),
                              onClick: _withModifiers($event => (_ctx.selectUser(user)), ["prevent"])
                            }, null, 10, _hoisted_22))
                          }), 128))
                        ], 512), [
                          [_vShow, _ctx.isOpen]
                        ]),
                        (_ctx.signatoryRequest.lawId == '')
                          ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                              _hoisted_24,
                              _createTextVNode(" Mandatory field ")
                            ]))
                          : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.editMode)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                        _createElementVNode("div", _hoisted_26, [
                          _createElementVNode("input", {
                            type: "text",
                            disabled: _ctx.editMode,
                            placeholder: "Law ID",
                            value: _ctx.signatoryRequest.lawId + ' - ' + _ctx.signatoryRequest.firstName + ' ' + _ctx.signatoryRequest.lastName
                          }, null, 8, _hoisted_27)
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.signatoryRequest.signatoryTypeId == 2)
            ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                _createElementVNode("fieldset", _hoisted_29, [
                  _hoisted_30,
                  _createElementVNode("div", _hoisted_31, [
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => ((_ctx.signatoryRequest.firstName) = $event)),
                      disabled: _ctx.isLoadingData,
                      placeholder: "First name",
                      onInput: _cache[8] || (_cache[8] = $event => (_ctx.mandatoryCheck())),
                      maxLength: "50"
                    }, null, 40, _hoisted_32), [
                      [_vModelText, _ctx.signatoryRequest.firstName]
                    ]),
                    _createElementVNode("div", {
                      class: _normalizeClass(["footnote", [ _ctx.signatoryRequest.firstName.length === 50 ? 'full' : '']])
                    }, _toDisplayString(_ctx.signatoryRequest.firstName.length) + "/50 characters ", 3),
                    (_ctx.signatoryRequest.firstName === '')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                          _hoisted_34,
                          _createTextVNode(" Mandatory field ")
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _createElementVNode("fieldset", _hoisted_35, [
                  _hoisted_36,
                  _createElementVNode("div", _hoisted_37, [
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => ((_ctx.signatoryRequest.lastName) = $event)),
                      disabled: _ctx.isLoadingData,
                      placeholder: "Last name",
                      onInput: _cache[10] || (_cache[10] = $event => (_ctx.mandatoryCheck())),
                      maxLength: "50"
                    }, null, 40, _hoisted_38), [
                      [_vModelText, _ctx.signatoryRequest.lastName]
                    ]),
                    _createElementVNode("div", {
                      class: _normalizeClass(["footnote", [ _ctx.signatoryRequest.lastName.length === 50 ? 'full' : '']])
                    }, _toDisplayString(_ctx.signatoryRequest.lastName.length) + "/50 characters ", 3),
                    (_ctx.signatoryRequest.lastName === '')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                          _hoisted_40,
                          _createTextVNode(" Mandatory field ")
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_41, [
            _createElementVNode("fieldset", _hoisted_42, [
              _hoisted_43,
              _createElementVNode("div", _hoisted_44, [
                _createElementVNode("div", _hoisted_45, [
                  _withDirectives(_createElementVNode("select", {
                    "onUpdate:modelValue": _cache[11] || (_cache[11] = $event => ((_ctx.signatoryRequest.categoryId) = $event)),
                    onChange: _cache[12] || (_cache[12] = $event => (_ctx.mandatoryCheck()))
                  }, [
                    _hoisted_46,
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.categoriesType, (c) => {
                      return (_openBlock(), _createElementBlock("option", {
                        value: c.id
                      }, _toDisplayString(c.name), 9, _hoisted_47))
                    }), 256))
                  ], 544), [
                    [_vModelSelect, _ctx.signatoryRequest.categoryId]
                  ]),
                  (_ctx.signatoryRequest.categoryId == '0')
                    ? (_openBlock(), _createElementBlock("span", _hoisted_48, [
                        _hoisted_49,
                        _createTextVNode(" Mandatory field ")
                      ]))
                    : _createCommentVNode("", true)
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_50, [
            _createElementVNode("fieldset", _hoisted_51, [
              _hoisted_52,
              _createElementVNode("div", _hoisted_53, [
                _createElementVNode("div", _hoisted_54, [
                  _withDirectives(_createElementVNode("select", {
                    "onUpdate:modelValue": _cache[13] || (_cache[13] = $event => ((_ctx.signatoryRequest.solelyJointlyId) = $event)),
                    disabled: _ctx.signatoryRequest.signatoryTypeId == 2,
                    onChange: _cache[14] || (_cache[14] = $event => (_ctx.mandatoryCheck()))
                  }, [
                    _hoisted_56,
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.solelyJointlyType, (sT) => {
                      return (_openBlock(), _createElementBlock("option", {
                        value: sT.id
                      }, _toDisplayString(sT.name), 9, _hoisted_57))
                    }), 256))
                  ], 40, _hoisted_55), [
                    [_vModelSelect, _ctx.signatoryRequest.solelyJointlyId]
                  ]),
                  (_ctx.signatoryRequest.solelyJointlyId == 0)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_58, [
                        _hoisted_59,
                        _createTextVNode(" Mandatory field ")
                      ]))
                    : _createCommentVNode("", true)
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_60, [
            _createElementVNode("fieldset", _hoisted_61, [
              _hoisted_62,
              _createTextVNode(" Please enter the date the person become a signatory "),
              _createElementVNode("div", _hoisted_63, [
                _createElementVNode("div", _hoisted_64, [
                  _createVNode(_component_v3_date_picker, {
                    class: "v3-date-picker",
                    style: {"padding":"1em"},
                    onClick: _cache[15] || (_cache[15] = $event => (_ctx.mandatoryCheck())),
                    modelValue: _ctx.signatoryRequest.commencedDate,
                    "onUpdate:modelValue": _cache[16] || (_cache[16] = $event => ((_ctx.signatoryRequest.commencedDate) = $event)),
                    inputFormat: "dd-MM-yyyy"
                  }, null, 8, ["modelValue"]),
                  _hoisted_65
                ])
              ])
            ]),
            _createElementVNode("fieldset", _hoisted_66, [
              _hoisted_67,
              _createTextVNode(" If ongoing, please leave blank "),
              _createElementVNode("div", _hoisted_68, [
                _createElementVNode("div", _hoisted_69, [
                  _createVNode(_component_v3_date_picker, {
                    class: "v3-date-picker",
                    style: {"padding":"1em"},
                    onClick: _cache[17] || (_cache[17] = $event => (_ctx.mandatoryCheck())),
                    modelValue: _ctx.signatoryRequest.terminatedDate,
                    "onUpdate:modelValue": _cache[18] || (_cache[18] = $event => ((_ctx.signatoryRequest.terminatedDate) = $event)),
                    inputFormat: "dd-MM-yyyy",
                    lowerLimit: _ctx.from
                  }, null, 8, ["modelValue", "lowerLimit"]),
                  _hoisted_70
                ])
              ])
            ])
          ]),
          _hoisted_71
        ])
      ]),
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_72, [
          (_ctx.editMode)
            ? (_openBlock(), _createElementBlock("div", _hoisted_73, [
                _createElementVNode("button", {
                  class: "btn btn-outline",
                  onClick: _cache[19] || (_cache[19] = $event => (_ctx.deleteAuthroisedSignatory())),
                  disabled: _ctx.isLoadingData
                }, "Delete", 8, _hoisted_74)
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", {
            class: _normalizeClass(_ctx.editMode ? 'col-6 right' : 'col-12 right')
          }, [
            _createElementVNode("button", {
              class: "btn btn-default",
              onClick: _cache[20] || (_cache[20] = $event => (_ctx.cancelClicked())),
              disabled: _ctx.isLoadingData
            }, "Cancel", 8, _hoisted_75),
            _createElementVNode("button", {
              class: "btn btn-primary ml-2",
              disabled: !_ctx.canSubmit || _ctx.isLoadingData,
              onClick: _cache[21] || (_cache[21] = $event => (_ctx.submit()))
            }, [
              _createTextVNode("Save "),
              _hoisted_77
            ], 8, _hoisted_76)
          ], 2)
        ])
      ]),
      _: 1
    }, 8, ["show"]),
    _createVNode(_component_ConfirmDialogue, {
      ref: "confirmTerminateDialogue",
      modalOpened: true
    }, null, 512),
    (_ctx.showCancelAlert)
      ? (_openBlock(), _createBlock(_component_AlertBox, {
          key: 1,
          onClose: _cache[26] || (_cache[26] = $event => (_ctx.showCancelAlert = false))
        }, {
          header: _withCtx(() => [
            _hoisted_78
          ]),
          body: _withCtx(() => [
            _hoisted_79
          ]),
          footer: _withCtx(() => [
            _createElementVNode("button", {
              class: "btn btn-secondary sml",
              onClick: _cache[24] || (_cache[24] = $event => (_ctx.yesClicked()))
            }, "Yes"),
            _createElementVNode("button", {
              class: "btn btn-tertiary sml",
              onClick: _cache[25] || (_cache[25] = $event => (_ctx.showCancelAlert = false))
            }, "No")
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ]))
}